import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, } from "react-router-dom";

// Components
import Panel from './Panels/Panel';
import ListPanel from "./Panels/ListPanel";
import ReviewsPanel from "./Panels/ReviewsPanel";
import Map from "./Map";

// Images
import conventionPic from '../Images/conventionPic.jpg';
import mugshot from '../Images/andreaPic.jpg';

// Context
import { RefContext } from "../App";

const Content = () =>{
    const navigate = useNavigate();

    const { aboutRef, datesRef, appRef, contentConfig, qualifications, locations } = useContext(RefContext);

    if(appRef.current){
        appRef.current.classList.remove('fullHeight');
        appRef.current.classList.remove('centerContent');
    }

    return(
        contentConfig &&
        <main>
            <div className="panelDuo">
                <Panel 
                    config={contentConfig[0]}
                    image={conventionPic}
                    altText={"Lady meditating in the glowing sun"}
                />
                <ListPanel config={contentConfig[1]} list={qualifications}/>
            </div>

            <div className="panelSoloReviews">
                <Panel
                    config={contentConfig[2]}
                    itemRef={aboutRef}
                    image={mugshot}
                    altText={"asds"}
                />
                <ReviewsPanel />
            </div>            
            
            <div ref={datesRef}></div>
            <h3 className="text-4xl font-semibold font-Poetson">Locations</h3>
            <h4>Select Marker to See Classes</h4>
            <Map locations={locations}/>
        </main>
    );
}

export default Content;